import React from "react";
import { Grid, Typography, Container, Box } from "@mui/material";
import { StyledTextareaAutosize } from "../../utilities/styles/checkoutPage.style";

interface OrderNotesSectionProps {
    orderType?: string;
    notes?: string;
    customNames: string[];
    deliveryOverrides: any[];
    pickupOverride: any[];
    selectedNames: string[];
    detailsExpended: boolean;
    orderPickListOptions: any[];
    organizationSettings: any;
    classes: any;
    validator: any;
    onChange: (e: any, fieldName: string) => void;
    onStateChange: (updates: any) => void;
}

const OrderNotesSection: React.FC<OrderNotesSectionProps> = ({
    orderType,
    notes,
    customNames,
    deliveryOverrides,
    pickupOverride,
    selectedNames,
    detailsExpended,
    orderPickListOptions,
    organizationSettings,
    classes,
    validator,
    onChange,
    onStateChange,
}) => {
    if (orderType !== "Delivery" && orderType !== "Pickup") {
        return null;
    }

    return (
        <Container
            className={classes.deliveryNote}
            component="main"
            disableGutters={false}
        >
            <Box>
                {organizationSettings?.ordersTermsMessage && (
                    <Typography variant="caption" component="div" gutterBottom mt={2}>
                        {organizationSettings.ordersTermsMessage}
                    </Typography>
                )}
                <Typography
                    sx={{
                        mt: 4,
                        mb: 2,
                        fontSize: { sm: "20px" },
                        fontWeight: 600,
                    }}
                    gutterBottom
                >
                    {orderType === "Delivery" ? "Delivery Note" : "Pickup Note"}
                </Typography>
                <Grid container spacing={2} direction="row" sx={{ width: { xs: "calc(100vw - 25px)", sm: "calc(100% + 16px)" } }}>
                    <Grid item xs={12} sm={12}>
                        <StyledTextareaAutosize
                            name="notes"
                            autoComplete="off"
                            className={classes.textareaBoxSize}
                            id="notes"
                            onChange={(e) => onChange(e, "notes")}
                            onBlur={() =>
                                validator.message(
                                    "notes",
                                    typeof notes === "string" ? notes.trim() : notes,
                                    "noSpecialChar"
                                )
                            }
                            maxRows={5}
                            minRows={5}
                            placeholder="e.g. Please double bag. (optional)"
                            value={notes || ""}
                        />
                        {validator.message("notes", notes, "noSpecialChar")}
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default OrderNotesSection;
